var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
// Requires: LayerGroupLayer, LayerGroupLayerManipulation
OCS.Viewer.Interfaces.LayerGroupTime = {
    latest_layer: null, // A pointer of sorts to the latest created layer
    earliest_layer: null, // A pointer of sorts to the active layer
    show_current_layer: null,
    times_to_ids: {},
    /*
     *  Time stamp related methods 
     */
    init_time: function () {
        this.show_current_layer = OCS.Viewer.Functions.get_utilities().create_debounced_method(this.show_current_frame_method.bind(this), 500);
        this.bound_events.time_update = this.on_time_update.bind(this);
    },
    init_time_events: function () {
        this.addEvent('destroy_layer_group', this.destroy_time.bind(this));
        this.addEvent('add_layer', this.on_add_layer_with_time.bind(this));
        this.addEvent('remove_layer', this.on_remove_layer_with_time.bind(this));
        this.addEvent('show_current_layer', this.show_current_layer.bind(this));
        var dateObj = this.get_map_datetime_obj();
        dateObj.addEvent('time_update', this.bound_events.time_update);

    },
    determine_group_timestamp_range: function (result) {
        if (!this.is_static()) {
            this.update_layers_info();
            var earliest = this.get_earliest_timestamp_epoch();
            if (result.newStartTS === null || result.newStartTS === 0 || (earliest < result.newStartTS && earliest !== null)) {
                result.newStartTS = earliest;
            }
            var latest = this.get_latest_timestamp_epoch();
            if (result.newEndTS === null || result.newEndTS === 0 || (latest > result.newEndTS && latest !== null)) {
                result.newEndTS = latest;
            }
            if (!result.newStartTS && result.newEndTS) {
                result.newStartTS = result.newEndTS;
            }
            if (!result.newEndTS && result.newStartTS) {
                result.newEndTS = result.newStartTS;
            }
        }
        return result;
    },
    get_earliest_layer: function () {
        return this.earliest_layer;
    },
    get_earliest_timestamp_epoch: function () {
        var util = OCS.Viewer.Functions.get_utilities();
        var timestamp = this.get_layer_timestamp_epoch(this.get_earliest_layer());
        if ((util.is_null(timestamp) || util.is_undefined(timestamp)) && this.options.init_start_timestamp_epoch) {
            timestamp = this.options.init_start_timestamp_epoch;
        }
        return timestamp;
    },
    update_earliest_layer: function () {
        // Assume the latest time possible and work backwards till we get an earlier timestamp
        var earliest = this.latest_layer;
        Object.each(this.layers, function (layer) {
            var layer_timestamp = layer.get_timestamp_epoch();
            if (earliest) {
                var earliest_layer_timestamp = earliest.get_timestamp_epoch();
                if (earliest_layer_timestamp > layer_timestamp) {
                    earliest = layer;
                }
            } else {
                earliest = layer;
            }
        }.bind(this));
        this.earliest_layer = earliest;
    },
    get_latest_layer: function () {
        return this.latest_layer;
    },
    get_latest_timestamp_epoch: function () {
        var util = OCS.Viewer.Functions.get_utilities();
        var timestamp = this.get_layer_timestamp_epoch(this.get_latest_layer());
        if (util.is_null(timestamp) || util.is_undefined(timestamp)) {
            timestamp = this.get_earliest_timestamp_epoch();
        }
        return timestamp;
    },
    get_layer_timestamp_epoch: function (layer) {
        if (layer) {
            return layer.get_timestamp_epoch();
        }
    },
    update_latest_layer: function (layer) {
        // If we have a layer test it against the latest timestamp, if not check all the layers
        if (layer) {
            var layer_timestamp = layer.get_timestamp_epoch();
            // Have to have a latest layer in order to test its timestamp
            if (this.latest_layer) {
                var latest_layer_timestamp = this.latest_layer.get_timestamp_epoch();
                if (latest_layer_timestamp < layer_timestamp) {
                    this.latest_layer = layer;
                }
            } else {
                this.latest_layer = layer;
            }
        } else {
            // Test each layer to see if its the latest
            var latest = null;
            Object.each(this.layers, function (layer) {
                var layer_timestamp = layer.get_timestamp_epoch();
                if (latest) {
                    var latest_layer_timestamp = latest.get_timestamp_epoch();
                    if (latest_layer_timestamp > layer_timestamp) {
                        latest = layer;
                    }
                } else {
                    latest = layer;
                }
            }.bind(this));
        }
    },

    get_active_timestamp_epoch: function () {
        return this.get_layer_timestamp_epoch(this.get_active_layer());
    },
    update_layers_info: function () {
        this.update_latest_layer();
        this.update_earliest_layer();
    },

    // Retrieve a layer based on its timestamp
    get_layer_with_timestamp_epoch: function (timestamp) {
        // Test that timestamp key exist
        if (this.times_to_ids[timestamp]) {
            return this.get_layer_with_id(this.times_to_ids[timestamp]);
        } else {
            return false;
        }
    },
    get_layer_in_step: function (step) {
        // Test that timestamp key exist
        var dateObj = this.get_map_datetime_obj();
        if (this.times_to_ids[step]) {
            // Simple it matches
            return this.get_layer_with_id(this.times_to_ids[step]);
        } else {
            // Well now we need to go searching for something that is close
            var available_timestamps = this.times_to_ids;
            var layer_timestamp = OCS.Viewer.Functions.get_utilities().object_has_object_with_cond(available_timestamps, function (id, timestamp) {
                // Test that we are in step
                if (dateObj.is_in_step(step, timestamp)) {
                    return true;
                }
            }.bind(this));
            if (layer_timestamp) {
                return this.get_layer_with_id(this.times_to_ids[layer_timestamp]);
            }
            return false;
        }
    },
    get_displayable_layer: function () {
        if (this.is_static()) {
            return this.get_active_layer();
        }

        var stale = this.get_stale_threshold();
        var dateObj = this.get_map_datetime_obj();
        var current_frame = dateObj.get_current_epoch_time();
        var layer, i, id, timestamp, frame, result;

        var stale_time = current_frame - stale;

        // If the current frame ties up perfectly with an existing time key, then return that layer, otherwise search for something close.
        layer = this.get_layer_with_timestamp_epoch(current_frame);
        if (layer) {
            // Layer has to have data for it to be displayable. 
            if (layer.is_ready) {
                return layer;
            } 
        }
        var available_timestamps = Object.keys(this.times_to_ids);

        // Filter the existing time keys to those keys within our stale timeframe. 
        var last_layer_frame = 0;
        var last_layer = null;

        for (i = 0; i < available_timestamps.length; i++) {
            timestamp = available_timestamps[i];
            frame = dateObj.get_frame_from_timestamp(timestamp);
            result = frame <= current_frame && stale_time <= frame;
            if (result) {
                // Grab the layer and see if it has data.
                id = this.times_to_ids[timestamp];
                layer = this.get_layer_with_id(id);
                if (layer && layer.is_ready) {
                    if (frame > last_layer_frame) {
                        last_layer_frame = frame;
                        last_layer = layer;
                    }
                }
            }
        }

        if (last_layer) {
            return last_layer;
        }
        return false;

    },
    show_current_frame_method: function () {
        if (this.is_ready) {
            this.fireEvent('activate_layer', this.get_displayable_layer());
        }
    },
    remove_old_layers: function () {
        var dateObj = this.get_map_datetime_obj();
        var start_epoch_ts = dateObj.get_start_epoch_time();
        start_epoch_ts = dateObj.get_frame_from_timestamp(start_epoch_ts);
        var layer_ts;
        if (!this.is_static()) {

            // Use the given start timestamp minus stale threshold of the layer to remove old layers.
            layer_ts = start_epoch_ts - this.get_stale_threshold();

            if (this.debug) {
                console.log('layer_group ' + this.get_layer_short_name() + ': Removing old ("' + this.get_layer_name() + '") layers before: ' + dateObj.get_utc_long_string(layer_ts));
            }
            Object.each(this.layers, function (layer, key) {
                if (layer_ts > layer.get_timestamp_epoch()) {
                    this.fireEvent('remove_layer', layer);
                }
                // If for some reason we have orphaned a layer, clean that up too.
                if (!layer.get_layer()) {
                    this.fireEvent('remove_layer', layer);
                }
            }.bind(this));
            this.update_earliest_layer();
        }
    },
    on_add_layer_with_time: function (layer_obj) {
        this.times_to_ids[layer_obj.get_timestamp_epoch()] = layer_obj.get_id();

        // Check if the layer we are adding has a timestamp greater than what we currently show
        this.update_latest_layer(layer_obj);

    },
    on_remove_layer_with_time: function (layer) {
        delete this.times_to_ids[layer.get_timestamp_epoch()];
    },
    on_time_update: function (time) {
        this.show_current_frame_method();
        var start = time.get_start_epoch_time();
        if (start > this.get_earliest_timestamp_epoch()) {
            this.remove_old_layers();
        }
    },
    destroy_time: function () {
        var dateObj = this.get_map_datetime_obj();
        dateObj.removeEvent('time_update', this.bound_events.time_update);

        this.earliest_layer = null;
        this.latest_layer = null;
        this.map_datetime_obj = null;
    }

};